module.exports = __webpack_public_path__ + "img/20240701085531579fel.39e02770.jpg";